export const NAV_MOBILE = document.querySelector("div.nav-mobile")
export const COLLAPSE_OPACITY_CLASS = "collapse"
